import { Directive, HostListener } from "@angular/core";

import * as _ from "lodash";

import { DialogService } from "../../dialog/dialog.service";

@Directive({
  selector: "[uex-image-viewer]",
  host: {
    "[class.uex-image-viewer-link]": "enabled && src"
  },
  inputs: ["src", "enabled: uex-image-viewer"]
})
export class ImageViewerDirective {
  public src: string;
  public set enabled(enabled: boolean) {
    this._enabled = _.isString(enabled) ? true : (enabled as boolean);
  }
  public get enabled(): boolean {
    return this._enabled;
  }

  private _enabled: boolean = true;

  @HostListener("click")
  private _onClick() {
    if (!this._enabled) return;

    this._dialogService.openViewer(this.src);
  }

  constructor(private _dialogService: DialogService) {}
}
